export default __webpack_public_path__ + "static/media/footer-top-shape.c1b42d66.webp";